import { render } from "./ProductReport.vue?vue&type=template&id=0e48320a&scoped=true&ts=true"
import script from "./ProductReport.vue?vue&type=script&lang=ts"
export * from "./ProductReport.vue?vue&type=script&lang=ts"

import "./ProductReport.vue?vue&type=style&index=0&id=0e48320a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e48320a"]])

export default __exports__